export function comingSoon() {
	const form = document.getElementById('coming-soon-form');
	const messageContainer = document.getElementById('coming-soon-message');

	if (!form) return;

	form.addEventListener('submit', async (e) => {
		e.preventDefault();

		const emailInput = form.querySelector('input[name="email"]');
		const submitButton = form.querySelector('button[type="submit"]');
		const email = emailInput.value.trim();

		// Basic validation
		if (!email) {
			showMessage(wpcore.direct_t({ en: 'Please enter your email address.', fr: 'Veuillez entrer votre adresse e-mail.' }), 'error');
			return;
		}

		// Email validation
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			showMessage(wpcore.direct_t({ en: 'Please enter a valid email address.', fr: 'Veuillez entrer une adresse e-mail valide.' }), 'error');
			return;
		}

		// Disable submit button during request
		submitButton.disabled = true;
		submitButton.textContent = wpcore.direct_t({ en: 'Submitting...', fr: 'Envoi en cours...' });

		try {
			const formData = new FormData();
			formData.append('action', 'wpcore_subscribe_coming_soon');
			formData.append('email', email);

			const response = await fetch(wpcore.ajaxUrl, {
				method: 'POST',
				body: formData
			});

			const data = await response.json();

			if (data.success) {
				showMessage(data.data.message, 'success');
				form.reset();
			} else {
				showMessage(data.data.message || wpcore.direct_t({ en: 'An error occurred. Please try again.', fr: 'Une erreur est survenue. Veuillez r\u00e9essayer.' }), 'error');
			}
		} catch (error) {
			console.error('Error:', error);
			showMessage(wpcore.direct_t({ en: 'An error occurred. Please try again.', fr: 'Une erreur est survenue. Veuillez r\u00e9essayer.' }), 'error');
		} finally {
			submitButton.disabled = false;
			submitButton.textContent = wpcore.direct_t({ en: 'Notify me', fr: 'Me notifier' });
		}
	});

	function showMessage(message, type) {
		if (!messageContainer) return;

		const bgColor = type === 'success' ? 'bg-green-100' : 'bg-red-100';
		const textColor = type === 'success' ? 'text-green-800' : 'text-red-800';

		messageContainer.innerHTML = `
			<div class="${bgColor} ${textColor} px-4 py-3 rounded text-sm">
				${message}
			</div>
		`;

		messageContainer.classList.remove('hidden');
		messageContainer.classList.add('block');

		// Auto-hide after 5 seconds
		setTimeout(() => {
			messageContainer.classList.remove('block');
			messageContainer.classList.add('hidden');
			messageContainer.innerHTML = '';
		}, 5000);
	}
}
